<template>
    <div class="main pay-complete">
        <div class="intro">
            <img src="../../assets/images/pay/other_pay_linepay2.svg" class="linepay-logo">

            <template v-if="isLoading">
                <h2 class="dark">資料處理中...</h2>
                <p>請勿關閉頁面</p>
                <i class="el-icon-loading"/>
            </template>
            <template v-else-if="isPayRequest">
                <h2 class="dark">請求付款成功</h2>
                <p class="dark">請操作原先的瀏覽器查看您的訂單</p>
            </template>
            <template v-else-if="isPayComplete">
                <h2 class="green">支付成功</h2>
            </template>
            <template v-else>
                <h2 class="red">{{ message }}</h2>
            </template>
        </div>
    </div>
</template>

<script>
    import * as constDefine from "@/store/constDefine";

    export default {
        name: "LinepayConfirm",

        data() {
            return {
                isLoading: true,
                isPayRequest: false,
                isPayComplete: false,
                message: "",
                dataObject: {},
                transactionId: this.$route.query.transactionId || '',
                tradeNo: this.$route.query.orderId || '',
            }
        },
        created() {
            let isSuccess = false

            try {
                try {
                    this.dataObject = this.$crypto.uriComponentToObject(this.$route.query.dataToken)
                } catch (e) {
                    this.dataObject = JSON.parse(this.$crypto.decryptText(this.$route.query.dataToken.replace(/ /g, "+")).toString())
                }

                if (this.dataObject.action === constDefine.LinePayOnlineApi.Request) {
                    if (this.dataObject.isConfirm) {
                        isSuccess = true
                        this.linePayRequestConfirm()
                        // this.linePayRequest()
                    } else if (this.dataObject.isCancel) {
                        this.message = "取消支付，請選擇其他支付方式"
                    } else {
                        this.message = "參數異常"
                    }
                } else {
                    this.message = "不提供該功能"
                }
            } catch (e) {
                this.message = "解密異常"
            }

            if(!isSuccess) {
                this.isLoading = false
                window.opener.postMessage({message: "fail"}, window.opener);
            }
        },
        mounted() {

        },
        methods: {
            linePayRequestConfirm() {//直接在這頁扣款建立訂單用
                this.$http.fetchWithEncrypt`LinePayRequestConfirm${{
                    "action": this.dataObject.action || "",
                    "payExecuteType": this.dataObject.payExecuteType || 0,
                    "payExecuteId": this.dataObject.payExecuteId || 0,
                    "transactionId": this.transactionId,
                    "tradeNo": this.tradeNo,
                    "os": this.$http.getOS(),
                }} ${json => {
                    this.isLoading = false
                    if (json.status) {
                        this.isPayComplete = true
                        window.opener.postMessage({message: "success"}, window.opener);
                    } else {
                        this.message = json.message
                        window.opener.postMessage({message: "fail"}, window.opener);
                    }
                }}`;
            },
            linePayRequest() {
                this.isLoading = false
                this.isPayRequest = true
                // window.location = "oinapp://oinapp.com/jump"
            },
        }

    }
</script>

<style lang="less" scoped src="../../less/pay.less"/>
<script setup lang="ts">
</script>